// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3rh_F","inner":"Footer_inner__hpSxT","nextIcon":"Footer_nextIcon__38F79","innerLeft":"Footer_innerLeft__1_8Q9"};